import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Card } from '../ui/Card';
import { ArrowRight, Layers, Globe, Wallet, RefreshCw, ShieldCheck, Coins, Droplets, Code2 } from 'lucide-react';
export function ProductSuite() {
  const products = [{
    title: 'Orchestrate',
    description: 'Coordinate payments, FX, wallets, liquidity, and compliance through a single intelligent layer.',
    icon: Layers,
    cta: 'View Orchestrate',
    href: '#products/orchestrate'
  }, {
    title: 'Payments',
    description: 'Collect and send money across borders using local rails, global payouts, and on-chain settlement.',
    icon: Globe,
    cta: 'View Payments',
    href: '#products/payments'
  }, {
    title: 'Wallets',
    description: 'Multi-currency and stablecoin wallets for businesses, platforms, and end users.',
    icon: Wallet,
    cta: 'View Wallets',
    href: '#products/wallets'
  }, {
    title: 'Exchange',
    description: 'Real-time FX conversion across fiat and stablecoins with transparent pricing.',
    icon: RefreshCw,
    cta: 'View Exchange',
    href: '#products/exchange'
  }, {
    title: 'Compliance',
    description: 'Built-in KYC, AML, transaction monitoring, and regulatory controls across jurisdictions.',
    icon: ShieldCheck,
    cta: 'View Compliance',
    href: '#products/compliance'
  }, {
    title: 'Tokenize',
    description: 'Create and manage tokenized balances, assets, and programmable money flows.',
    icon: Coins,
    cta: 'View Tokenization',
    href: '#products/tokenize'
  }, {
    title: 'Liquidity',
    description: 'Access pooled liquidity across banks, market makers, and on-chain sources.',
    icon: Droplets,
    cta: 'View Liquidity',
    href: '#products/liquidity'
  }, {
    title: 'Connect',
    description: 'APIs, webhooks, and SDKs to integrate Obseq into your product or platform.',
    icon: Code2,
    cta: 'View Developer Tools',
    href: '#products/connect'
  }];
  const container = {
    hidden: {
      opacity: 0
    },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };
  return <section className="py-24 bg-slate-50" data-id="element-523">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-524">
        <div className="text-center max-w-3xl mx-auto mb-12 sm:mb-16" data-id="element-525">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-slate-900 mb-4" data-id="element-526">
            Product Suite
          </h2>
          <p className="text-base sm:text-lg text-slate-600" data-id="element-527">
            Modular infrastructure to move, manage, and program money globally.
          </p>
        </div>

        <motion.div variants={container} initial="hidden" whileInView="show" viewport={{
        once: true,
        margin: '-100px'
      }} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-528">
          {products.map(product => <a key={product.title} href={product.href} data-id="element-529">
              <Card interactive className="flex flex-col h-full group text-center sm:text-left items-center sm:items-start" data-id="element-530">
                <div className="w-12 h-12 rounded-lg bg-slate-100 flex items-center justify-center mb-6 group-hover:bg-blue-50 group-hover:text-blue-600 transition-colors" data-id="element-531">
                  <product.icon className="w-6 h-6" data-id="element-532" />
                </div>
                <h3 className="text-xl font-semibold text-slate-900 mb-3" data-id="element-533">
                  {product.title}
                </h3>
                <p className="text-slate-600 text-sm leading-relaxed mb-6 flex-grow" data-id="element-534">
                  {product.description}
                </p>
                <div className="flex items-center text-sm font-medium text-slate-900 group-hover:text-blue-600 transition-colors mt-auto" data-id="element-535">
                  {product.cta}
                  <ArrowRight className="ml-2 w-4 h-4 transition-transform group-hover:translate-x-1" data-id="element-536" />
                </div>
              </Card>
            </a>)}
        </motion.div>
      </div>
    </section>;
}